export default __webpack_public_path__ + "static/Montserrat-500italic-c90ced68b46050061d1a41842d6dfb43.woff2";